<style scoped lang="scss">
  form {
      h2 {
          color: #000;
      }
      ::v-deep(.formkit-select-icon) {
          height: 50px;
          margin: 0;
          padding: 0;
      }
  }
  main .container .card {
    background-color: rgba(91, 91, 98, 0.08);
  }
</style>

<template>
  <div class="mb-5">
    <h1 class="page-title">{{ title }}</h1>
  </div>
  <div class="max-w-screen-xl mx-auto">
    <div class="flex flex-wrap -mx-4">
      <div class="w-full lg:w-1/4 px-3">
        <div class="mb-5">
          <div class="card w-75 shadow-xl" v-show="isEditSubCategory === false">
            <div class="card-body items-center text-center">
              <h5 class="card-title">Miniature</h5>
              <UploadImage :image-preview-url="form.vignette ? form.vignette.url : getBaseUrl() + '/media/blank2.png'"
                  @image-removed="onImageRemoved"
                  @imageUploaded="onImageUpload"
                  @error="onImageUploadError"
              />
            </div>
              <div class="card-body items-center text-center">
                  <h5 class="card-title">Icone 3d</h5>
                  <UploadImage :image-preview-url="form.icon3d ? form.icon3d.url : getBaseUrl() + '/media/blank2.png'"
                               @image-removed="onImageRemoved3d"
                               @imageUploaded="onImageUpload3d"
                               @error="onImageUploadError"
                               :acceptedExtensions="['.png']"
                  />
              </div>
          </div>
        </div>
      </div>

      <div class="w-full lg:w-3/4 px-4">
        <div class="card w-full shadow-xl">
          <div class="card-body">
            <h5 class="card-title">Général</h5>
            <div class="w-full">
              <FormKit type="form"
                :actions="false"
                :model="form"
                @submit="onSubmit"
                #default="{ state: { valid } }"
                outer-class="w-full"
                incomplete-message="Veuillez remplir tous les champs correctement"
              >

                <div class="mt-2">
                  <div class="flex">
                    <div class="mr-3"><label for="status">Statut</label></div>
                    <div>
                      <span :class="{
                        'badge': true,
                        'badge-error': !form.enabled,
                        'badge-success': form.enabled,
                        'badge-circle': true
                      }"></span>
                    </div>
                  </div>
                  <FormKit
                    type="select"
                    name="status"
                    v-model="form.enabled"
                    help="Faire apparaitre ou non la catégorie dans le catalogue"
                    :options="[
                      { label: 'Activé', value: true },
                      { label: 'Désactivé', value: false },
                    ]"
                  />
                </div>

                <FormKit type="text"
                  name="slug"
                  v-model="form.slug"
                  label="Slug *"
                  validation="required | matches:/^[^\s][a-zA-Z0-9-_/%]*$/"
                  :validation-messages="{
                    required: 'Le slug est obligatoire',
                    matches: 'Le slug ne doit contenir que des lettres, des chiffres, des tirets et des slashs et ne doit pas commencer par un espace',
                  }"
                />
                <FormKit type="text"
                  name="name"
                  label="Nom *"
                  v-model="form.name"
                  validation="required | length:1,30"
                  :validation-messages="{
                    required: 'Le nom est obligatoire',
                    length: 'Le nom ne doit pas dépasser 30 caractères',
                  }"
                />
                <FormKit type="textarea"
                  name="description"
                  label="Description"
                  v-model="form.description"
                  validation="length:0,255"
                  :validation-messages="{
                    length: 'La description ne doit pas dépasser 255 caractères',
                  }"
                />
                <div class="card-actions">
                  <div v-if="loading === false">
                    <FormKit type="submit"
                      :label="submitBtnLabel"
                      :disabled="!valid"
                      :class="{ 'btn-primary': true, 'btn-block': true }"
                    />
                  </div>
                  <FormKit type="button"
                    label="Annuler"
                    @click="onCancel"
                    :class="{ 'btn-secondary': true, 'btn-block': true }"
                  />
                </div>
              </FormKit>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onBeforeMount, ref } from 'vue';
import { useRoute } from 'vue-router';
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import { useRouter } from "vue-router";
import UploadImage from "@/components/forms/UploadImage.vue";
import { ICategory } from "@/models/category/ICategory";
import { ICategoryForm } from "@/models/category/ICategoryForm";
import { fetchCategory } from "@/_services/category/category";

const title = ref<string>("Edition de catégorie");
const submitBtnLabel = 'Editer';
const isEditSubCategory = ref<boolean>(false);
const category = ref<ICategory>({} as ICategory);
const route = useRoute();
const uuidRouteParam = ref<string>("");
const router = useRouter();
const loading = ref<boolean>(true);

onBeforeMount(async () => {
  uuidRouteParam.value = route.params.uuid.length ? route.params.uuid as string : "";
  if (uuidRouteParam.value.length) {
    category.value = await fetchCategory(uuidRouteParam.value);
    await hydrateCategoryForm(category.value);
    title.value = category.value.lvl > 1 ? "Edition de sous-catégorie" : "Edition de catégorie"
    isEditSubCategory.value = category.value.lvl > 1;
    originalForm.value = form.value;
    loading.value = false;
  }
});

const form = ref<ICategoryForm>({
  name: '',
  slug: '',
  description: '',
  parent: null,
  parentValue: null,
  enabled: true,
  vignette: null,
  icon3d: null  ,
});
const originalForm = ref<ICategoryForm>({
  name: '',
  slug: '',
  description: '',
  parent: null,
  parentValue: null,
  enabled: true,
  vignette: null,
  icon3d: null  ,  
});

const hydrateCategoryForm = (category: ICategory) => {
    console.log(category.icon3d);
  form.value = {
    name: category.name,
    slug: category.slug,
    description: category.description,
    enabled: category.enabled,
    parent: category.parentObject,
    parentValue: null,
    vignette: category.vignette, 
    icon3d: category.icon3d,  
  }
}

const onSubmit = async (formData, formNode) => {
  try {
    const payload = {
      name: formData.name,
      slug: formData.slug,
      description: formData.description,
      enabled: formData.status,
      vignette: null !== form.value.vignette ? `/api/images/${form.value.vignette.uuid}` : null, 
      icon3d: null !== form.value.icon3d ? `/api/images/${form.value.icon3d.uuid}` : null
    }
    swal.confirm(
      isEditSubCategory.value === false
      ? `Êtes-vous sûr de vouloir ${submitBtnLabel} cette catégorie ?`
      : `Êtes-vous sûr de vouloir ${submitBtnLabel} cette sous-catégorie ?`,
      "Annuler",
      submitBtnLabel
    )
    .then((results) => results.isConfirmed && updateCategorie(payload))
  } catch (err: any) {
    swal.error(err.errors[0]);
  }
}

const updateCategorie = (data) => {
  if(uuidRouteParam.value.length) {
    ApiService.patch('categories', uuidRouteParam.value, data)
    .then((response) => {
      swal.info("La catégorie " + response.data.data.name + " a été édité avec succès")
      .then((result) => {
        if (result.isConfirmed) {
          category.value.parentObject?.lvl === 0
            ? router.push({ name: "listCategories" })
            : router.push({
              name: "listCategories",
              params: { uuid: category.value.parentObject?.uuid },
            });
        }
    });
    })
    .catch((error) => {
      swal.error("Une erreur est survenue lors de la modification de la catégorie");
    });
  }
}

const onCancel = () => {
  swal.confirm(
    isEditSubCategory.value === false
      ? "Êtes-vous sûr de vouloir annuler l'édition de la catégorie ?"
      : "Êtes-vous sûr de vouloir annuler l'édition de la sous-catégorie ?",
    "Oui",
    "Non"
  ).then((result) => {
      if (result.isDismissed) {
        router.push({
          name: "listCategories",
          params: { uuid: category.value.parentObject?.uuid },
        });
      }
  });
}

const onImageUpload = (image) => {
  form.value.vignette = image;
}

const onImageRemoved = () => {
  form.value.vignette = null;
}

const onImageUpload3d = (image) => {
    form.value.icon3d = image;
}

const onImageRemoved3d = () => {
    form.value.icon3d = null;
}

const onImageUploadError = (errorMsg: string) => {
  swal.error(errorMsg);
}

function getBaseUrl() {
  return window.location.origin;
}
</script>